const removeFirstLegDisruptionsFromLaterLegs = (legs) => {
  var _a;
  const [firstLeg, ...nonFirstLegs] = legs;
  const firstLegDisruptionIds = (_a = firstLeg.disruptions) == null ? void 0 : _a.map((disruption) => disruption == null ? void 0 : disruption.id);
  const TSILegWithFirstDisruptionMarked = [
    firstLeg,
    ...nonFirstLegs.map((leg) => {
      var _a2;
      return {
        ...leg,
        disruptions: ((_a2 = leg == null ? void 0 : leg.disruptions) == null ? void 0 : _a2.filter((disruption) => disruption && !(firstLegDisruptionIds == null ? void 0 : firstLegDisruptionIds.includes(disruption == null ? void 0 : disruption.id)))) || null
      };
    })
  ];
  return TSILegWithFirstDisruptionMarked;
};
var removeFirstLegDisruptionsFromLaterLegs_default = removeFirstLegDisruptionsFromLaterLegs;
export {
  removeFirstLegDisruptionsFromLaterLegs_default as default
};
